import * as Cookies from 'js-cookie';
import * as sjcl from 'sjcl';

const EXPIRES_REMEMBER_ME_COOKIE = 30; // 30 days
// eslint-disable-next-line no-unused-vars
const EXPIRES_TIME_REMEMBER_ME_COOKIE = new Date(
  // eslint-disable-next-line no-mixed-operators
  new Date().getTime() + 15 * 60 * 1000
); // 15 minutes

// Create cookie remember me valid for EXPIRES_REMEMBER_ME_COOKIE days and
// (secure:true) cookie transmission requires a secure protocol (https)
export const createRememberMeCookie = value =>
  Cookies.set('remember-me', sjcl.encrypt('password', value.toString()), {
    expires: EXPIRES_REMEMBER_ME_COOKIE,
    secure: true
  });

export const getRememberMeCookie = () => {
  const value = Cookies.get('remember-me');
  return value ? sjcl.decrypt('password', value) : false;
};
export const removeRememberMeCookie = () => Cookies.remove('remember-me');
